// websites/heartfelt-ai/src/App.jsx
import { AuthProvider } from "@shared/context/AuthContext";
import SiteThemeProvider from "@shared/context/SiteThemeProvider";
import { WebsiteProvider } from "@shared/context/WebsiteContext";
import { AnimationProvider } from "@shared/features/transitions";
import { ToastProvider } from "@shared/context/ToastContext";
import AppRoutes from "./Routes";
import siteConfig from "./config/siteConfig";

function App() {
  const websiteId = import.meta.env.VITE_WEBSITE_ID;

  return (
    <WebsiteProvider websiteId={websiteId} websiteConfig={siteConfig}>
      {/* SiteThemeProvider applies website-specific theme colors */}
      <SiteThemeProvider>
        <AnimationProvider>
          <AuthProvider>
            <ToastProvider>
              <AppRoutes />
            </ToastProvider>
          </AuthProvider>
        </AnimationProvider>
      </SiteThemeProvider>
    </WebsiteProvider>
  );
}

export default App;
